import { LogoTerraform } from "components/icons/generated";
import VendorVersion from "components/VendorVersion";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";
import { getModulePullRequestSingleRun } from "../../../helpers";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestVendorCell = ({
  item: pullRequest,
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableRow>) => {
  const singleRun = getModulePullRequestSingleRun(pullRequest.runs);

  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!singleRun && <TableCellEmpty />}

      {!!singleRun && (
        <VendorVersion
          icon={LogoTerraform}
          text={singleRun.runtimeConfig?.terraform?.version ?? undefined}
        />
      )}
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestVendorCell;
